export class OriginValidationService {
    public isAllowedOrigin(origin: string, allowedPattern: string): boolean {
        const regexPattern = allowedPattern.replace('.', '\\.').replace('*', '.+');
        const regex = new RegExp(`^${regexPattern}$`);

        return regex.test(origin);
    }
}
